export default __webpack_public_path__ + "static/media/7.58e07d70.jpg";